const WritingAdvisor = ({ sentences }: any) => {

  if (!sentences) return <></>;

  return (
    <>
      {
        sentences?.map((sentence: any, index: number) => {
          const { corrected_text, similar_text } = sentence?.data;
          return (
            <div key={index} className="adv-item">
              <div className="adv-cell">
                <div className="header">Revised Sentence</div>
                <div className="body">
                  <div className="cont">
                    {corrected_text}
                  </div>
                </div>
              </div>
              <div className="adv-cell">
                <div className="header">Similar Sentence</div>
                <div className="body">
                  <div className="cont">
                    {similar_text}
                  </div>
                </div>
              </div>
            </div>
          )
        })
      }
    </>
  )
}

export default WritingAdvisor;